//Patterns
export const FETCH_PATTERNS_REQUEST = "FETCH_PATTERNS_REQUEST";
export const FETCH_PATTERNS_SUCCESS = "FETCH_PATTERNS_SUCCESS";
export const FETCH_PATTERNS_FAIL = "FETCH_PATTERNS_FAIL";

//DB Extractor
export const POST_DBEXT_REQUEST = "POST_DBEXT_REQUEST";
export const POST_DBEXT_SUCCESS = "POST_DBEXT_SUCCESS";
export const POST_DBEXT_RESET = "POST_DBEXT_RESET";
export const POST_DBEXT_FAILURE = "POST_DBEXT_FAILURE";

//Custom Extractor
export const POST_CUSTOMEXT_REQUEST = "POST_CUSTOMEXT_REQUEST";
export const POST_CUSTOMEXT_SUCCESS = "POST_CUSTOMEXT_SUCCESS";
export const POST_CUSTOMEXT_FAILURE = "POST_CUSTOMEXT_FAILURE";
export const POST_CUSTOMEXT_RESET = "POST_CUSTOMEXT_RESET";

//Ext List
export const FETCH_EXTLIST_REQUEST = "FETCH_EXTLIST_REQUEST";
export const FETCH_EXTLIST_SUCCESS = "FETCH_EXTLIST_SUCCESS";
export const FETCH_EXTLIST_FAILURE = "FETCH_EXTLIST_FAILURE";

//Extractor List
export const FETCH_EXTRACTOR_LIST_REQUEST = "FETCH_EXTRACTOR_LIST_REQUEST";
export const FETCH_EXTRACTOR_LIST_SUCCESS = "FETCH_EXTRACTOR_LIST_SUCCESS";
export const FETCH_EXTRACTOR_LIST_FAILURE = "FETCH_EXTRACTOR_LIST_FAILURE";

// Get Extractor Detail
export const FETCH_EXTRACTOR_DETAIL_REQUEST = "FETCH_EXTRACTOR_DETAIL_REQUEST";
export const FETCH_EXTRACTOR_DETAIL_SUCCESS = "FETCH_EXTRACTOR_DETAIL_SUCCESS";
export const FETCH_EXTRACTOR_DETAIL_FAILURE = "FETCH_EXTRACTOR_DETAIL_FAILURE";

// Delete Extractor
export const DELETE_EXTRACTOR_REQUEST = "DELETE_EXTRACTOR_REQUEST";
export const DELETE_EXTRACTOR_SUCCESS = "DELETE_EXTRACTOR_SUCCESS";
export const DELETE_EXTRACTOR_FAILURE = "DELETE_EXTRACTOR_FAILURE";

// PUT Extractor
export const PUT_EXTRACTOR_REQUEST = "PUT_EXTRACTOR_REQUEST";
export const PUT_EXTRACTOR_SUCCESS = "PUT_EXTRACTOR_SUCCESS";
export const PUT_EXTRACTOR_SKIP = "PUT_EXTRACTOR_SKIP";
export const PUT_EXTRACTOR_FAILURE = "PUT_EXTRACTOR_FAILURE";
export const PUT_EXTRACTOR_RESET = "PUT_EXTRACTOR_RESET";

// Get Extractor Status
export const FETCH_EXTRACTOR_STATUS_REQUEST = "FETCH_EXTRACTOR_STATUS_REQUEST";
export const FETCH_EXTRACTOR_STATUS_SUCCESS = "FETCH_EXTRACTOR_STATUS_SUCCESS";
export const FETCH_EXTRACTOR_STATUS_FAILURE = "FETCH_EXTRACTOR_STATUS_FAILURE";
export const FETCH_EXTRACTOR_STATUS_RESET = "FETCH_EXTRACTOR_STATUS_RESET";

// Post Extractor Schema
export const POST_EXTRACTORSCHEMA_REQUEST = "POST_EXTRACTORSCHEMA_REQUEST";
export const POST_EXTRACTORSCHEMA_SUCCESS = "POST_EXTRACTORSCHEMA_SUCCESS";
export const POST_EXTRACTORSCHEMA_FAILURE = "POST_EXTRACTORSCHEMA_FAILURE";

//POST RETRY UPDATE SCHEMA EXT
export const POST_RETRYSCHEMAUPDATE_REQUEST = "POST_RETRYSCHEMAUPDATE_REQUEST";
export const POST_RETRYSCHEMAUPDATE_SUCCESS = "POST_RETRYSCHEMAUPDATE_SUCCESS";
export const POST_RETRYSCHEMAUPDATE_FAILURE = "POST_RETRYSCHEMAUPDATE_FAILURE";